import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootStateInterface } from "reducer";
import { AuthStateInterface } from "scenes/AuthPage/interfaces";

import BurgerButton from "components/buttons/Burger/Burger";

import ArrowIcon from "../../assets/icons/arrow-left.svg";
import logo from "../../assets/logotype.svg";

import styles from "./header.module.scss";

interface HeaderInterface {
  title?: string;
  isFullFill?: boolean;
  backPath?: string;
}

const Header = ({ isFullFill, backPath }: HeaderInterface) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { jwtData } = useSelector<RootStateInterface, AuthStateInterface>(
    (state) => state.auth
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 20) {
        setIsScrolled(true);
      } else setIsScrolled(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={styles["header"]}>
      <div
        className={classNames(styles["header__wrapper"], {
          [styles["header__ful-fill-wrapper"]]: isFullFill,
          [styles["header__wrapper--scrolled"]]: isScrolled
        })}
      >
        <BurgerButton />
        {backPath && jwtData?.sub !== "share-token" && (
          <Link to={backPath} className={styles["header__logo"]}>
            <img src={ArrowIcon} alt="Dropla Logo"></img>
          </Link>
        )}

        <Link
          to="/"
          className={classNames(styles["header__logo"], {
            [styles["header__logo--disabled"]]: jwtData?.sub === "share-token"
          })}
        >
          <img src={logo} alt="Dropla Logo"></img>
        </Link>
      </div>
    </header>
  );
};

export default Header;
